import MandecarComponent from 'components/marketingSite/mandecar23/Mandecar';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { ServiceServicePublicStats } from 'services/service.public-stats';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type Mandecar23PageProps = WithBaseUrl & { manfreditesCount: number };

const Mandecar23Page: React.FC<Mandecar23PageProps> = ({
  baseUrl,
  manfreditesCount
}) => {
  const { t } = useI18n('developer-career-report-2023');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('mandecar23.page_title')}
        url={APP_URLS.mandecar23}
        desc={t('mandecar23.page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_developer_career_report_2023.png'
        )}`}
      />
      <MandecarComponent manfreditesCount={manfreditesCount} />
    </>
  );
};

export default Mandecar23Page;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const { manfreditesCount } = await ServiceServicePublicStats.get();

  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'developer-career-report-2023'
      ])),
      baseUrl: config.appUrl,
      manfreditesCount
    },
    revalidate: 30
  };
};
